import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG } from '../../../../theme/Component/hooks/useModal';
import { _EmployeeContract, _single } from '../../../../../core/services/dataBean/EntityCatalog';
import usePaginator from '../../../../theme/Component/usePaginator';
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER, MASK_TEXT_NOWRAP } from '../../../../theme/Component/BasicTable';
import { Modal } from '../../../../theme/Component/Modal';
import { MultiAccountanEditor } from '../../../../editor/MultiAccountanEditor';
import { EmploymentTypeEditor } from '../ComponentsContract/EditorsEmployeContrac/EmploymentType.editor';
import { SelectFunctionalID } from '../../../../admin/configuracion/functionalID/SelectFunctionalID';
import { EntailmentEditor } from '../../../ParametrosTalentoHumano/Entailment/Entailment.editor';
import { AppointmentEditor } from '../../../ParametrosTalentoHumano/Appointment/Appointment.editor';
import { SelectSiteID } from '../../../../admin/configuracion/SiteID/SelectSiteID';
import { SelectMonths } from '../../../../contract/select/SelectMonths';
import { ConstractStateEditor } from '../ComponentsContract/EditorsEmployeContrac/ConstractState.editor';
import { YearSelector } from '../../../../../core/shared/inputs/YearSelector';
import { BasicButton } from '../../../../theme/Component/BasicButton';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const EmployeeHistoryEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_EmployeeContract)
    const [id, setID] = useState(null);
    const [year, setyear] = useState<number>(_single.getCurrenYear())
    const [employmentType, setEmploymentType] = useState<number>(null);
    const [idSite, setIdSite] = useState<number>(null);
    const [regexStx, setRegexStx] = useState<string>(null);
    const [funtional, setFuntional] = useState<number>(null);
    const [entailment, setEntailment] = useState<number>(null);
    const [appointment, setAppointment] = useState<number>(null);
    const [month, setMonth] = useState<number>(_single.getCurrentMonth());
    const [contractState, setContractState] = useState<number>(2);
    const [listaAccs, setListaAccs] = useState<any>([]);
    const modal = useModal("Historial de Contratos de Trabajo", MODAL_LG);
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [paginador.page])
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDContract == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getEmployeeContracts(year, month, listaAccs.length ? listaAccs : null, employmentType ? [employmentType] : null, funtional, entailment, appointment, contractState, idSite, regexStx, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'IDContrato', property: 'IDContract', visible: true, mask: MASK_NUMBER },
        { title: 'Usuario', property: 'AccountName', visible: true, mask: MASK_TEXT_NOWRAP },
        // { title: 'Perfil de Liquidación', property: 'IDEmployeeLiquidate', visible: true },
        { title: 'Nivel Jerárquico', property: 'EntailmentName', visible: true },
        { title: 'Nivel Salarial/Grado', property: 'AppointmentName', visible: true },
        { title: 'Tipo Vinculación', property: 'ContractTypeName', visible: true },
        { title: 'ID Plaza Laboral', property: 'IDLnFunctionalArea', mask: MASK_NUMBER, visible: true },
        { title: 'Plaza Laboral', property: 'FunctionalAreaName', visible: true },
        { title: 'Código Posición Jerárquica', property: 'FunctionalIDJsonCode', visible: true },
        { title: 'Nombre Posición Jerárquica', property: 'FunctionalIDName', visible: true },
        { title: 'Fecha de Inicio', property: 'InitContract', mask: MASK_DATE, visible: true },
        { title: 'Ingreso Nación', property: 'NationInit', mask: MASK_DATE, visible: true },
        // { title: 'Utilizar Tipo de Payroll', property: 'UsePayrollType', visible: true },
        // { title: 'Tipo de Payrol', property: 'PayrollTypeName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreCode', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
        { title: 'EPS', property: 'EPSName', visible: true },
        { title: 'ARP', property: 'ARPName', visible: true },
        { title: 'CCF', property: 'CCFName', visible: true },
        { title: 'Fondo Pensional', property: 'FPName', visible: true },
        { title: 'Fondo Cesantías', property: 'FCEName', visible: true },
        { title: 'Tipo de Salario', property: 'RevenueType', visible: true },
        { title: 'Salario', property: 'Revenue', mask: MASK_MONEY, visible: true },
        { title: 'Usar Salario Definido en el Contrato', property: 'UseContractSalaryValue', visible: true },
        { title: 'Salario Definido por Contrato', property: 'ContractSalaryValue', mask: MASK_MONEY, visible: true },
        { title: 'Tipo Riesgo', property: 'ARPRiskName', visible: true },
        { title: 'Tipo Cotizante', property: 'EmployeeTypeName', visible: true },
        { title: 'Subtipo Cotizante', property: 'EmployeeSubtypeName', visible: true },
        { title: 'Fecha Renuncia', property: 'EndingDate', mask: MASK_DATE, visible: true },
        { title: 'Estado', property: 'ContractStateName', visible: true },
        { title: 'Fecha Liquidación', property: 'UptoContract', mask: MASK_DATE, visible: true },
        { title: 'Fecha de Nacimiento', property: 'BornDate', mask: MASK_DATE, visible: true },
        { title: 'Dirección', property: 'Address', mask: MASK_TEXT_NOWRAP, visible: true },
        { title: 'Teléfono', property: 'Tel', visible: true },
        { title: 'Correo Electrónico', property: 'eMail', visible: true },
        { title: 'Género', property: 'GenType', visible: true },
        { title: 'Resposable ImpoRenta', property: 'RentTax', visible: true },
        { title: 'Último Exámen Médico', property: 'HealthTestDate', mask: MASK_DATE, visible: true },
        { title: 'Últimas Vacaciones', property: 'LastVacDate', mask: MASK_DATE, visible: true },
        { title: 'Última Dotación', property: 'LastEndowmentDate', mask: MASK_DATE, visible: true },
        { title: 'Tipo de Empleo', property: 'EmploymentTypeName', visible: true },
        { title: 'Código CIIU', property: 'CIIUCode', mask: MASK_NUMBER, visible: true },
        { title: 'Subtipo ARL', property: 'ARPRiskName', visible: true },
        { title: 'Tipo de Contrato', property: 'EmployeeContractType', visible: true },
        { title: 'Definir Límite de UVTs', property: 'UseUVTMaxRetefuente', visible: true },
        { title: 'Limite UVTs', property: 'UVTMaxRetefuente', visible: true },
        { title: 'Ciudad de Ejecución del Contrato', property: 'SiteIDName', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: true },
        { title: 'Actualizado por', property: 'LastUpdateEmployeeName', visible: true },
        { title: 'Método de Cálculo', property: 'IDTaxRetentionMethodName', visible: true },
        { title: '% Fijo de Retención para el Procedimiento 2', property: 'TaxRetentionPercent2', visible: true },
        { title: 'Fecha Última Actualización', property: 'LastUpdate', visible: true, mask: MASK_DATE },
        { title: 'Unidad de Negocio', property: 'BusinessCoreCode', visible: true },
        { title: 'Definir Centro de Costo', property: 'UseOwnCostingCenter', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Utilizar Tipo de Payroll', property: 'UsePayrollType', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Recurso"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                        <MultiAccountanEditor values={listaAccs} label="Filtro Empleados" onChange={(e) => { setListaAccs(e) }} />
                    </div>
                    <div className="col-md-4">
                        <EmploymentTypeEditor label="Tipo de Grupo Laboral" idSelector={employmentType} onChange={(e) => { setEmploymentType(e) }} />
                    </div>
                    <div className="col-md-4">
                        <SelectFunctionalID label="Unidad Organizacional" onChange={(e) => { setFuntional(e?.IDLn) }} />
                    </div>
                    <div className="col-md-4">
                        <EntailmentEditor label="Nivel Jerárquico" idSelector={entailment} onChange={(e) => { setEntailment(e) }} />
                    </div>
                    <div className="col-md-4">
                        <AppointmentEditor label="Nivel Salarial" idSelector={appointment} onChange={(e) => { setAppointment(e) }} />
                    </div>
                    <div className="col-md-4">
                        <SelectSiteID label="Ubicación Geográfica" edit idLnSite={idSite} onChange={(e) => { setIdSite(e.IDLn) }} />
                    </div>
                    <div className="col-md-4">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStx} onChange={(e) => { setRegexStx(e.target.value) }} />
                    </div>
                    <div className="col-4">
                        <label>Vigencia:</label>
                        <YearSelector value={year} tittle="Año" onChange={(e) => { setyear(e) }} />
                    </div>
                    <div className="col-4">
                        <SelectMonths idSelector={month} onChange={(e) => { setMonth(e) }}></SelectMonths>
                    </div>
                    <div className="col-4">
                        <ConstractStateEditor label="Estado del Contrato" idSelector={contractState} onChange={(e) => { setContractState(e) }} />
                    </div>
                    <div className="col-md-4">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                            Consultar
                        </BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDContract); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}